<div mat-dialog-content [ngClass]="{ 'show-viewer': !loading }" style="opacity: 0;">
  <button mat-mini-fab matTooltip="Close" matTooltipPosition="below" class="close-icon" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <a mat-mini-fab class="download-btn" matTooltip="Download" matTooltipPosition="below"
    href="https://drive.fevertreefinance.co.za/file/fetch/zeropay-terms-conditions" target="_blank">
    <mat-icon>download</mat-icon>
  </a>
  <pdf-viewer (after-load-complete)="loading = false;" mat-dialog-content
    src="https://drive.fevertreefinance.co.za/file/fetch/zeropay-terms-conditions" [render-text]="true"
    style="display: block;"></pdf-viewer>
</div>
<div class="loading-overlay" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
